/*
 * @Author: lizhihong lizhihong@broadptt.com
 * @Date: 2023-11-03 10:26:21
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-07-09 19:31:10
 * @FilePath: \broad_dispatching_platform\src\api\beasconfig.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// const baseconfig = { //测试
//   xinextendUrlapi: 'https://apidev.xin-ptt.com:9001/pocextend',
//   apiAudioUrl: "http://apidev.xin-ptt.com/pocAudio", //测试录音文件平台
//   gpsUrlapi: "http://apidev.xin-ptt.com/pocgps", //测试定位地址
//   mmsUrlapi: "https://apidev.xin-ptt.com:9001/mms", //广播
//   videoUrlapi: "https://apidev.xin-ptt.com:9001/video", //视频
//   sosUrlapi: "https://apidev.xin-ptt.com:9001/sos-ptt03", //sos
//   regionUrlapi: "https://apidev.xin-ptt.com:9001/region", //区域群组
//   enclosureUrlapi: "https://apidev.xin-ptt.com:9001/enclosure-ptt03",                               //电子围栏
//   selfUrlapi: "http://apidev.xin-ptt.com/pocToCApi",
//   getDownPath: "https://apidev.xin-ptt.com:20008",
//   httpXin: 'broaddev.xin-ptt.com:1,broaddev.xin-ptt.com:10003',
//   typeName: 'xin_poc',
//   ak: "gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8", //测试定位地址
//   tokenSl: { "Content-Type": "application/x-www-form-urlencoded" },
//   xinPatrolApi: 'https://apidev.xin-ptt.com:9001/xinpocPatrol'//巡更地址
// };

//传奇数码-测试
// const baseconfig = {
//   xinextendUrlapi: 'https://test.poc-global.com/extend',
//   apiAudioUrl: "https://test.poc-global.com/audio", //测试录音文件平台
//   gpsUrlapi: "https://test.poc-global.com/gps", //测试定位地址
//   mmsUrlapi: "https://test.poc-global.com/mms", //广播
//   videoUrlapi: "https://test.poc-global.com/video-ptt", //视频
//   sosUrlapi: "https://test.poc-global.com/sos-api", //sos
//   regionUrlapi: "https://apidev.xin-ptt.com:9001/region", //区域群组
//   enclosureUrlapi: "https://test.poc-global.com/enclosure-api",
//   selfUrlapi: "https://test.poc-global.com/xintoc",                         //电子围栏
//   getDownPath: "https://apidev.xin-ptt.com:20008",
//   ak: "gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8", //测试定位地址
//   tokenSl: { "Content-Type": "application/x-www-form-urlencoded" },
//   httpXin: '8.219.116.42:10013',
//   typeName: 'xinpoc_test'
// };

const baseconfig = {  //正式
  xinextendUrlapi:'https://proxy.xinpoc.com/extend',
  apiAudioUrl: "https://proxy.xinpoc.com/audio", //测试录音文件平台
  gpsUrlapi: "https://proxy.xinpoc.com/gps", //测试定位地址
  mmsUrlapi: "https://apidev.xin-ptt.com:9001/mms", //广播
  videoUrlapi: "https://apidev.xin-ptt.com:9001/video", //视频
  sosUrlapi: "https://proxy.xinpoc.com/sos-api", //sos
  regionUrlapi: "https://apidev.xin-ptt.com:9001/region", //区域群组
  enclosureUrlapi:"https://proxy.xinpoc.com/enclosure-api",      
  selfUrlapi: "https://proxy.xinpoc.com/xintoc",                         //电子围栏
  getDownPath:"https://apidev.xin-ptt.com:20008",
  ak: "gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8", //测试定位地址
  tokenSl:{ "Content-Type": "application/x-www-form-urlencoded" },
  httpXin:'schedule1.xinpoc.com:10003,schedule2.xinpoc.com:10003',
  typeName:'poclarge',
  xinPatrolApi: 'https://proxy.xinpoc.com/patrol'//巡更地址
};

// const baseconfig = {  //美国访问正式
//   xinextendUrlapi:'https://api.global-ptt.com/extend',
//   apiAudioUrl: "https://api.global-ptt.com/audio", //测试录音文件平台
//   gpsUrlapi: "https://api.global-ptt.com/gps", //测试定位地址
//   mmsUrlapi: "https://apidev.xin-ptt.com:9001/mms", //广播
//   videoUrlapi: "https://apidev.xin-ptt.com:9001/video", //视频
//   sosUrlapi: "https://api.global-ptt.com/sos-api", //sos
//   regionUrlapi: "https://apidev.xin-ptt.com:9001/region", //区域群组
//   enclosureUrlapi:"https://apidev.xin-ptt.com:9001/enclosure",      
//   selfUrlapi: "http://xintoc.xinpoc.com:30002",                         //电子围栏
//   getDownPath:"https://apidev.xin-ptt.com:20008",
//   ak: "gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8", //测试定位地址
//   tokenSl:{ "Content-Type": "application/x-www-form-urlencoded" },
//   httpXin:'schedule1.xinpoc.com:10003,schedule2.xinpoc.com:10003',
//   typeName:'poclarge',
//   xinPatrolApi: 'https://dmp.hpyjcloud.com/patrol'//巡更地址
// };

// const baseconfig = {        //春盛正式环境API
//   xinextendUrlapi: 'https://dmp.hpyjcloud.com/extend',
//   apiAudioUrl: 'https://dmp.hpyjcloud.com/recordapi',//录音文件平台
//   gpsUrlapi: 'https://dmp.hpyjcloud.com/gps',//定位地址
//   mmsUrlapi: 'https://dmp.hpyjcloud.com/mms',//广播
//   videoUrlapi: 'https://dmp.hpyjcloud.com/video',//视频
//   sosUrlapi: 'https://dmp.hpyjcloud.com/sos',//sos
//   regionUrlapi: "https://dmp.hpyjcloud.com/region", //区域群组
//   enclosureUrlapi: "https://dmp.hpyjcloud.com/enclosure",                               //电子围栏
//   getDownPath: "https://dmp.hpyjcloud.com:20008",
//   ak: 'gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8',//定位地址
//   tokenSl: { "Content-Type": "application/x-www-form-urlencoded" },
//   socketPz: '47.101.42.90:10002',
//   poc: 'csptt',
//   xinPatrolApi: 'https://dmp.hpyjcloud.com/patrol'//巡更地址
// }

export default baseconfig;
